/* DR sticky buy bar (phones). Shows once the page's own buy buttons have
   scrolled out of view above, hides again when they're back. The bar's button
   submits the main product form (form="product-form-…"), so Dawn's
   product-form.js adds to cart and opens its notification as usual. */
(() => {
  const bar = document.querySelector('[data-dr-sticky-buy]');
  if (!bar || !('IntersectionObserver' in window)) return;
  const target = document.querySelector(bar.dataset.target);
  if (!target) return;
  const show = (on) => {
    bar.hidden = !on;
    document.body.classList.toggle('dr-sticky-buy-on', on);
  };
  new IntersectionObserver(([entry]) => {
    show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
  }).observe(target);
})();
